import { render, staticRenderFns } from "./TagReport.vue?vue&type=template&id=0f36e44d&"
import script from "./TagReport.vue?vue&type=script&lang=js&"
export * from "./TagReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports